import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import * as fromStore from "../store";
import { Observable, of } from "rxjs";
import { filter, map, switchMap, take, catchError } from "rxjs/operators";
import { EntraIdGroup } from "../services/entra-id.service";

@Injectable()
export class AuthzGuard {
  constructor(private store: Store<fromStore.SharedState>, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    const allowedGroups = route.data["securityGroups"] as string[];
    if (!allowedGroups || allowedGroups.length === 0) {
      console.warn("AuthzGuard: No security groups specified for this route.");
      return of(this.router.createUrlTree(["noaccess"]));
    }
    return this.checkStore().pipe(
      switchMap(() =>
        this.store.select(fromStore.getGroupsEntities).pipe(
          take(1),
          map((entities: Record<string, EntraIdGroup>) => {
            const hasAccess = allowedGroups.some((group) => !!entities[group]);
            return hasAccess ? true : this.router.createUrlTree(["noaccess"]);
          }),
          catchError(() => of(this.router.createUrlTree(["noaccess"]))),
        ),
      ),
    );
  }

  private checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getGroupsLoaded).pipe(
      filter((loaded) => {
        if (!loaded) {
          this.store.dispatch(fromStore.fetchEntraIdGroups());
        }
        return loaded;
      }),
      take(1),
    );
  }
}
